class AccordionEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $(document).ready(function() {
      $(".c-flex__spMenu").addClass("is-color");
      $(".c-flex__spMenu-archive").addClass("is-color");
      $(".c-flex__spMenu-column").addClass("is-color");
    
      $(".c-qa__q, .c-flex__spMenu, .c-flex__spMenu-archive, .c-flex__spMenu-column").on('click', function() {
        $(this).toggleClass('is-active').next().slideToggle();
      });
    
      if (window.innerWidth <= 768) {
        $(".c-flex__menu-item").on('click', function() {
          var newText = $(this).text();
          $(".c-flex__spMenu").text(newText).addClass("is-color");
          $(".c-flex__spMenu-archive").text(newText).addClass("is-color");
          $(".c-flex__menu").fadeToggle();
        });
      }
    });
  }
}